import LocalSeoPage from '@/pages/local/components/LocalSeoPage';
import { aracruzCaldeiraria } from '@/mocks/localSeoData';

export default function CaldeirariaSoldaAracruz() {
  return <LocalSeoPage data={aracruzCaldeiraria} />;
}